import {createUseStyles} from 'react-jss'

import {
  BREAKPOINTS,
  COLORS
} from '~styles/vars.styles'

import backgroundImage from '~images/photos/yellow-send.jpg';

export default createUseStyles({
  sendNotifications: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: COLORS.ACCENT,
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    padding: 60,
    [`@media (min-width: ${BREAKPOINTS.HERO_BIG}px)`]: {
      padding: 120
    }
  },

  title: {
    color: COLORS.BLUE_MUTED_01,
    fontSize: 45,
    letterSpacing: '-0.045em',
    lineHeight: '1.25em',
    fontWeight: 600,
    marginBottom: 30,
    [`@media (min-width: ${BREAKPOINTS.HERO_BIG}px)`]: {
      padding: 60
    }
  },

  titleLine: {
    display: 'flex',
    alignItems: 'center'
  },

  titleIcon: {
    marginLeft: 20
  },

  button: {
    fontSize: 20,
    [`@media (min-width: ${BREAKPOINTS.HERO_BIG}px)`]: {
      fontSize: 28
    }
  },

  alternate: {
    color: COLORS.BLUE_02,
    fontWeight: 600,
    marginTop: 30
  },

  alternateLink: {
    color: COLORS.BLUE_02,
    textDecoration: 'underline'
  }
})